import fieldType from '@/enums/fieldType'
import vuei18n from '@/plugins/vuei18n'

export default class Role {
  constructor () {
  }

  isProtectedRole(role){
    return ['admin','leader','creator','worker','inactive'].includes(role)
  }
  translateRole(role){
    if(this.isProtectedRole(role)){
      return vuei18n.t('roles.system.' + role)
    }
    return role
  }

  translatePermission(permision){
    return vuei18n.t('roles.permissions_list.' + permision)
  }

}
